import React from 'react';

interface SpacerProps {
  color?: string;
  height?: number;
  marginY?: number;
}

export const Spacer: React.FC<SpacerProps> = ({
  color = '#000',
  height = 1,
  marginY = 16,
}) => (
  <hr
    style={{
      width: '100%',
      height: `${height}px`,
      color,
      margin: `${marginY}px 0`,
    }}
  />
);
